import { onMounted, onUnmounted, ref } from 'vue'

// A reveal that lives and dies with the component that asks for it: no storage, no
// counter-word, gone on the next page load. It is what guards a control that acts
// on a record rather than one that only shows something.
//
// The app-wide reveal - the one typed on any page, remembered until unrevelio - is
// `useRevealed` in helpers/revelio.
export function useRevelio(word = 'revelio') {
  const revealed = ref(false)
  let buffer = ''

  const onKeydown = e => {
    // Single printable characters only; ignore shortcuts and modifier combos.
    if (!e.key || e.key.length !== 1) return
    if (e.metaKey || e.ctrlKey || e.altKey) return

    buffer = (buffer + e.key.toLowerCase()).slice(-word.length)
    if (buffer === word) {
      buffer = ''
      revealed.value = true
    }
  }

  onMounted(() => window.addEventListener('keydown', onKeydown))
  onUnmounted(() => window.removeEventListener('keydown', onKeydown))

  return { revealed }
}
